// extracted by mini-css-extract-plugin
module.exports = {"bar":"AppBar_bar__3pq61"};